export default __webpack_public_path__ + "app/src/scenes/instand/biomarkers/empty_fig/Result_Not_Available.png";